import { createContext } from 'react';
import { Lessonstatusdetails } from '@/models';

export const ActiveLessonStatusesContext = createContext<{
  lessonStatus: Lessonstatusdetails | null;
  setLessonStatus: any;
}>({ lessonStatus: null, setLessonStatus: () => {} }); //using any for user as it's server defined
